import { FileStatuses } from 'src/utils/Constants';

export const normalizeFileName = (name: string): string => {
  name = name.replace(
    new RegExp(`^${FileStatuses.New}|${FileStatuses.Pending}`),
    ''
  );
  return `${FileStatuses.New}${name}`;
};
